import {IProductShort} from 'modules/products/types';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {IPagination} from 'core/models';

export interface IGetCatalogProductRecommendationsFilterData {
    id: string;
    location: string;
    selector: ProductRecommendationsType[];
}

export interface IGetProductRecommendationsFilter {
    filter: IGetCatalogProductRecommendationsFilterData;
}

export interface IGetProductRecommendationsProps {
    data: IGetProductRecommendationsFilter;
}

export type TGetRecommendationsPropsType =
    | 'similar_in_flavor'
    | 'recently_viewed'
    | 'popular'
    | 'new'
    | 'personal'
    | 'popular_rcs'
    | 'popular_es';

export interface IGetRecommendationsProps {
    data: {
        type: TGetRecommendationsPropsType;
        filter?: {
            staticUnifierItemNo?: IProduct['staticUnifier'];
            article?: IProduct['id'];
        };
        pagination?: {
            page: number;
            limit: number;
        };
    }[];
    location?: {
        source?: 'app' | 'web';
        page?: 'favorite' | 'pdp' | 'main' | 'personalAccount';
    };
}

export enum ProductRecommendationsType {
    WebOtherItemsOfTheBrandPdp = 'web_other_items_of_the_brand_pdp',
    SimilarInFlavor = 'similar_in_flavor',
    Personal = 'personal',
    WebPdpPurchasedTogether = 'web_pdp_purchased_together',
    RecentlyViewed = 'recently_viewed',
    Popular = 'popular_rcs',
}

export interface IRecommendationsResponseItem {
    items: IProductShort[];
    type: TGetRecommendationsPropsType;
    title: string;
    pagination?: IPagination;
}

export interface IRecommendationsResponse {
    data: {
        items: IRecommendationsResponseItem[];
    };
}
